import type { FC } from "react";

import type { Pages, SecondaryLayoutData } from "~/core";
import { SecondaryHeader } from "~/features/secondary-header/SecondaryHeader";
import { useAction } from "~/widgets/use-action";

export const SecondaryLayoutHeader: FC<{ data: SecondaryLayoutData }> = ({
  data,
}) => {
  const { callAction: onCallAction, isActionInactive } = useAction("header");

  const getUrl = (detailedPage: Pages): string => {
    if (!detailedPage?.slug) {
      return `/`;
    }

    const { segment, slug } = detailedPage;
    if (segment) {
      return `/${segment}/${slug}`;
    } else {
      return `/${slug}`;
    }
  };

  return (
    <SecondaryHeader
      data={data}
      onCallAction={onCallAction}
      isActionInactive={isActionInactive}
      getUrl={getUrl}
    />
  );
};
